import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../Hook/useAxios";
import '@justinribeiro/lite-youtube';

function SpecificVideo() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [video, setVideo] = useState(null);
    // on requête allArticles car l'article ciblé ne renvoies pas toutes les infos (header image par exemple)
    // Dans le useEffect grace a l'id dans le useParam on viens trouver le bon article et on reformate l'object pour l'affichage
    const allVideos = useAxios("/videos?populate=*");

    useEffect(() => {
        let title = "";
        let metaDescription = "";

        const saveVideo = () => {
            if (allVideos) {
                const video = allVideos.data.data.filter(
                    (video) => video.id === Number(id)
                );
                const newVideo = video.map((item) => ({
                    id: item.id,
                    title: item.attributes.title,
                    description: item.attributes.description,
                    url: item.attributes.url,
                    content: item.attributes.content,
                    category: item.attributes.categories.data.map(
                        (category) => ({
                            name: category.attributes.name,
                            visible: category.attributes.visible,
                        })
                    ),
                }));
                setVideo(newVideo);
                title = newVideo[0].title;
                metaDescription =  newVideo[0].description;
            }			
        };
        saveVideo();

        // set page title
        document.title = title + ' - Parlons Règles';
        const metaDescriptionTag = document.querySelector('meta[name="description"]');
        if (metaDescriptionTag) {
            metaDescriptionTag.setAttribute('content', metaDescription);
        }

    }, [allVideos, id]);

    const handleClick = () => {
        navigate("/Jeunes/ToutSurLesRegles");        
    };

    return (
        <div className="specificArticle">
            {video && (
                <>
                    <lite-youtube class="specificArticle__header" videoid={video[0].url.substring(30,41)} videoplay="Voir" videotitle={video[0].title} posterquality="maxresdefault" autopause>
                        <a href={video[0].url}>Voir sur YouTube: {video[0].title}</a>
                    </lite-youtube>
                    <div className="specificArticle__title-container">
                        <h2 className="specificArticle__title">
                            {video[0].title}
                        </h2>
                    </div>
                    <div className="specificArticle__container-categories">
                        {video[0].category.map(
                            (cat, index) =>
                                cat.visible && (
                                    <span
                                        className="specificArticle__categories"
                                        key={index}
                                    >
                                        #{cat.name}
                                    </span>
                                )
                        )}
                    </div>
                    <div className="specificArticle__content" dangerouslySetInnerHTML={{ __html: video[0].content}}>
                    </div>
                    <button
                        className="specificArticle__button"
                        onClick={handleClick}
                    >
                        Voir plus de videos
                    </button>
                </>
            )}
        </div>
    );
}

export default SpecificVideo;
